<template style="overflow: auto; height:100%;">
    <form @submit.prevent="" style="height:100%;">
        <h4 class="modal-header" ref="modalHeader">
          {{table?'Edit':'Create'}} table
          <!-- <button type="button" tabindex="-1" class="close wj-hide">&times;</button> -->
        </h4>
        <div class="modal-body">
            <label>
                Table name:
            </label>
            <input class="form-control form-control-sm selectors input-name" :disabled="editmode" v-model="name" />
          <br />
          <label>
            Columns:
          </label>
            <wj-flex-grid 
                :itemsSource="columns" 
                :initialized="flexInitialized" 
                :autoGenerateColumns="false" 
                :allowAddNew="true" 
                :newRowAtTo="false" 
                :rowHeight="31"
                :allowDelete="true"
                :allowSorting="false"
                autoSizeMode="Both"
                allowResizing="Both"
                :deferResizing="true"
                >
                <!-- :selectionChanged="startEditing"  -->
                <!-- :gotFocus="startEditing" -->
                <wj-flex-grid-column header="Name" :dataType="1" :isRequired=true :binding="'name'">
                </wj-flex-grid-column>
                <wj-flex-grid-column header="Type" >
                    <wj-flex-grid-cell-template cellType="Cell" :binding="'type'" v-slot="cell" width="*"> 
                    <!-- <wj-flex-grid-cell-template cellType="CellEdit" :binding="'type'" v-slot="cell" width="*">  -->
                        <!-- <div class="container"> -->
                            <!-- :itemsSource="typeList"  -->
                            <!-- v-model="cell.item.type" -->
                            <wj-combo-box
                                class="cell-editor"
                                :itemsSource="customTypList(cell.item.type)" 
                                :isEditable="true"
                                :textChanged="selectedType"                                
                                >
                                <!-- :selectedValue.sync="cell.item.type" -->
                                <!-- :isDroppedDownChanged="row"
                                :initialized="initComboObject"
                                :lostFocus="selectedType" -->
                                <!-- {{ cell.item.type  }} -->
                            </wj-combo-box>         
                        <!-- </div> -->
                    </wj-flex-grid-cell-template>
                </wj-flex-grid-column>
                <wj-flex-grid-column header="PK" :binding="'pk'" :dataType="3" />
                <wj-flex-grid-column header="FK" :binding="'fk'" :dataType="3" />
                <wj-flex-grid-column header="FK table" :binding="'linktable'" :dataMap="gridtablemap" />
                <wj-flex-grid-column header="Identity" :binding="'Identity'" :dataType="3" />
                <wj-flex-grid-column header="NOT NULL" :binding="'nullable'" :dataType="3" />
                <!-- <wj-flex-grid-column header="Comment" :isRequired=true :binding="'comment'" /> -->
                <wj-flex-grid-column header="" :width="30" :height="30" :isReadOnly="true">
                    <wj-flex-grid-cell-template cellType="Cell"  v-slot="cell">
                        <div style="height:22px;" title="Delete column">
                            <!-- <svg width="16px" height="16px" viewBox="3 3 10 10" v-on:click="DeleteColumn(cell.item, cell.row._idx)" class="bi bi-x close" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> -->
                            <svg width="16px" height="16px" viewBox="3 3 10 10" v-on:click="DeleteColumn(cell.item, cell.row._idx)" class="bi bi-x close" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </div>
                    </wj-flex-grid-cell-template>
                </wj-flex-grid-column>
            </wj-flex-grid>
            <br />
            <div style="display: flex">
                <button class="btn btn-primary" v-on:click="CreateTable()">Save</button>
                <button class="btn btn-primary cancel" v-on:click="Cancel()">Cancel</button>
            </div>
        </div>
        <modal name="open-identity" :clickToClose="false">
            <div class="identity-all">
                <div class="identity-header">
                    <h3 class="identity-title">Identity options</h3>
                    <a v-on:click="CloseDialogModal()" title="Close" class="close">×</a>
                </div>  
                <div class="identity-body">  
                    <div class="input-wrapper">
                        <div class="seed-wraper">
                            <label for="nameSeed">Seed</label>
                            <input type="number" id="idSeed" name="nameSeed" step="1" v-model="seed" @change="chekIdentityProp">
                        </div>
                        <div class="Increment-wraper">
                            <label for="nameIncrement">Increment</label>
                            <input type="number" id="idIncrement" name="nameIncrement" step="1" v-model="increment" @change="chekIdentityProp">
                        </div>
                    </div>
                </div>
                <div class="buttons">
                    <button class="btn btn-primary" v-on:click="CloseIdentity()">OK</button>
                </div>
            </div>
        </modal>
    </form>
</template>
<script>

import 'bootstrap/dist/css/bootstrap.css';
import '@grapecity/wijmo.styles/wijmo.css';
import '@grapecity/wijmo.vue2.core';
import '@grapecity/wijmo.vue2.input';
import { commonMixin } from '../common.js';
import "@grapecity/wijmo.vue2.grid";
import * as wjcGrid from "@grapecity/wijmo.grid";

export default {
    mixins: [commonMixin],
    data(){
        return {
            typeSelect:{val:'',row:'',col:''},
            name: '',
            // typeList: this.customTypList(),
            columnsCancel: [{}],
            columns: [{}],
            ancorColumns: null,
            flex: null,
            gridtypemap:null,
            gridtablemap:null,
            seed: 1,
            increment: 1,
            identityRow: null,
            seedSelected: null,
            incrementSelected: null,
            comment: [],
            delColumnQuery: '',
            rename: [],
            alterColumn: [{}],
            deleteColumn: [],
            addColumn: [],
            addProp:[],
            alterColumnQuery:[],
            renameQuery: [],
            arr: []
        }
    },
    computed:{
        /*
        hasPK(){
            if(!this.columns)return false;
            for (let i = 0; i < this.columns.length; i++) {
                const e = this.columns[i];
                if(e.pk)
                    return true;
            }
            return false;
        },
        */ 
         typelist(){
            console.log('typelist');
            let r = [];
            for (const key in this.typemap2) {
                if (this.typemap3.hasOwnProperty(key)) {
                    const t = this.typemap2[key];
                    r.push({id:key,name:t});
                }
            }
            return r;
        },
        editmode(){
            return this.table !== null;
        },
    },
    /*
    watch:{        
        columns:{            
            handler(v){              
                for (let i = 0; i < v.length; i++) {
                    const e = v[i];
                    if(e.pk){
                        if (e.fk)
                            this.$set(e,'fk', false);
                        if (e.nullable)
                            this.$set(e,'nullable', true);
                    }
                    if(e.fk){
                        if (e.pk)
                            this.$set(e,'pk', false);
                        let fktype = '';
                        if(e.linktable){
                            let tables = this.GetTables(this.db, 2);
                            for (let j = 0; j < tables.length; j++) {
                                const tbl = tables[j];
                                if(tbl.tablename == e.linktable){
                                    for (let k = 0; k < tbl.fields.length; k++) {
                                        const field = tbl.fields[k];
                                        if(field.subtype === 1){
                                            fktype = ''+field.type;
                                            break;
                                        }
                                    }
                                    break;
                                }
                            }
                        }
                        if (e.type !== fktype)
                            this.$set(e,'type', fktype);
                    }
                    else{
                        if (e.linktable !== '')
                            this.$set(e,'linktable', '');
                    }
                    if(e.comment) {

                    }
                }                
            },
            deep: true,
        }        
    },
    */
    props: {
        table: {
            required: true,
            validator: prop => typeof prop === 'object' || typeof prop === 'undefined' || prop === null
        },
        db: {
            required: true,
            type: Object,
        },
        tab:{
            required: true,
            type: Object,
        },
        state: {
            required: true,
            type: Object,
        }
    },
    created(){
        console.log('created');
        if(this.table){
            this.name = this.table.tablename;
            this.columns = [];
            for (let i = 0; i < this.table.fields.length; i++) {
                const e = this.table.fields[i];
                // console.log('this.table.fields[i]', this.table.fields[i]);
                console.log('this.typePrecisionCreated', this.typePrecision(this.table.fields[i]))
                
                this.columns.push({
                    type:''+this.typePrecision(this.table.fields[i]),
                    name:e.name,
                    subtype:e.subtype,
                    nullable: e.nullable==0 ? 1 : 0 ,
                    linktable:e.linktable,
                    pk:e.subtype==1,
                    fk:e.subtype==2, 
                    readonly:true,
                    Identity:e.increment ? true : false,
                    index: i,
                    precision: e.precision,
                    scale: e.scale
                });
                // this.columnsCancel.push({type:''+e.type,name:e.name,subtype:e.subtype,nullable: e.nullable==0 ? 1 : 0 ,linktable:e.linktable,pk:e.subtype==1,fk:e.subtype==2, readonly:true, comment: this.commentS ? this.commentS[i] : "",Identity:e.increment ? true : false});
                // this.columns.push({type:''+e.type,name:e.name,subtype:e.subtype,nullable:e.nullable,linktable:e.linktable,pk:e.subtype==1,fk:e.subtype==2, readonly:true});
            }
            // this.type = this.typemap5
            // console.log('this.type',this.type);
            // console.log('columns',this.columns);
        }
        this.seedSelected = this.seed;
        this.incrementSelected = this.increment;
        this.ancorColumns = this.columns.length;
    },
    mounted() {
        setTimeout(function(){
            document.querySelector('.selectors').focus();
        },50)
    },
    methods:{
        row() {
            console.log('row');
        },
        initComboObject(combo) {
            console.log('combo',combo);
        },
        initComboString(s) {
            console.log('initComboString',s);
        },
        selectedType(cell) {
            console.log('selectedType cell:',cell.text);
            console.log('selectedType cell:',window.hostname.rowEdit);
            // console.log('selectedTypeCol', wijmo.input.ComboBox );
            this.typeSelect.val = cell.text
            console.log('selectedType_columns:',this.columns);
            console.log('selectedTypeCol',this.columns[window.hostname.rowEdit]);
            if (this.columns[window.hostname.rowEdit] !== undefined) {
                this.columns[window.hostname.rowEdit].type = cell.text                
            }
        },
        onTextChanged(s,e) {
        //     console.log('onTextChanged',s);
        //     this.ty = s.text
        },        
        typePrecision(fld) {                           
            let val = ''
            let type = this.typemap[fld.type+'-'+fld.subtype]
            
            if (fld.precision != 0 && fld.precision != -1) {
                switch (+fld.type) {
                case 12:
                    val = ` (${fld.precision},${fld.scale}) `
                    break;
                    
                case 5:
                    if(fld.precision == 7) {
                        type = 'datetime'
                        val = ` (${fld.precision}) `
                    } else if((fld.precision == 3)) {
                        type = 'datetime'
                        val = ``
                    }
                    break;

                default:
                    val = ` (${fld.precision}) `
                    break;
                }      
            } else if (fld.precision == -1) {
                val =` (max) `
        } 
        let str =  type + val
        console.log('str: ', str); 
        // console.log('typePrec',str);
        return str
        },
        customTypList(type) { 
            // console.log('customTypList',type);
            // if (window.hostname.rowEdit != undefined) {
            //     console.log('customTypList',this.columns[window.hostname.rowEdit].type);                
            // }
            let arr = [
                'bigint',
                'binary(50)',
                'bit',
                'char(10)',
                'date',
                'datetime',
                'datetime2(7)',
                'decimal(18,0)',
                'double',
                'int',
                'nvarchar(50)',
                'nchar(10)',
                'nvarchar(MAX)',
                'rowversion',
                'varbinary(50)',
                'varbinary(MAX)',
                'varchar(50)',
                'varchar(MAX)'
            ]
            arr.unshift(type)
            // this.typemap5.forEach(el => {
            //     arr.push(el)
            // })
            // console.log('customTypList: ',arr);

            return arr
            // return 'bigint binary(50) bit char(10) date datetime datetime2(7) decimal(18,0) double int nvarchar(50) nchar(10) nvarchar(MAX) rowversion varbinary(50) varbinary(MAX) varchar(50) varchar(MAX)'.split(' ');
        },
        CloseIdentity() {           
            console.log('CloseIdentity');
            this.chekIdentityProp()
            this.columns[this.identityRow].increment = this.increment
            this.columns[this.identityRow].seed = this.seed
            this.CloseDialogModal()
            this.identityRow = null
        },
        CloseDialogModal(){
            this.$modal.hide('open-identity');
        },
        Cancel() { 
                      
            // this.columns = this.columns.slice(0, this.ancorColumns)
                this.columns = []
                this.table.fields.forEach((el,i) => {                
                    let it = {type:''+this.typePrecision(el),name:el.name,subtype:el.subtype,nullable: el.nullable==0 ? 1 : 0 ,linktable:el.linktable,pk:el.subtype==1,fk:el.subtype==2, readonly:true, comment: "",Identity:el.increment ? true : false, index: i,precision:el.precision}
                    // console.log('it', it.type);
                    this.columns.push(it);
                })
            // console.log('Cancel',this.columns); 
            setTimeout( () => {
                this.columns = []
                this.table.fields.forEach((el,i) => {                
                    let it = {type:''+this.typePrecision(el),name:el.name,subtype:el.subtype,nullable: el.nullable==0 ? 1 : 0 ,linktable:el.linktable,pk:el.subtype==1,fk:el.subtype==2, readonly:true, comment: "",Identity:el.increment ? true : false, index: i,precision:el.precision}
                    // console.log('it', it.type);
                    this.columns.push(it);
                })    
                
            }
            ,100)
            /*
            for (let i = 0; i < this.table.fields.length; i++) {
                // console.log('fields', i);
                const e = this.table.fields[i];
                let el = {type:''+this.typePrecision(e),name:e.name,subtype:e.subtype,nullable: e.nullable==0 ? 1 : 0 ,linktable:e.linktable,pk:e.subtype==1,fk:e.subtype==2, readonly:true, comment: this.commentS ? this.commentS[i] : "",Identity:e.increment ? true : false, index: i,precision:e.precision}
                console.log('el', el);
                this.columns.push(el);    
            }
            */ 
            this.delColumnQuery = ''            
            this.deleteColumn = []  
            this.addProp = [] 
            this.addColumn= [] 
            this.alterColumn = [] 
            this.arr = [] 
        }, 
        secondCancel() {
            setTimeout(this.Cancel(),1000)
        },
        chekIdentityProp() {          
            // console.log('chekIdentityProp');
            this.seed = Math.round(this.seed)
            this.increment = Math.round(this.increment)
            if (this.seed < 1) {
                this.seed = 1
            }
            if ( this.increment < 1) {
                this.increment = 1
            }

        },
        CloseDialogCancel() {
          this.seed = this.seedSelected;
          this.increment = this.incrementSelected;
        },
        // CloseDialog() {         
        //   this.seedSelected = this.seed;
        //   this.incrementSelected = this.increment;
        // },
        flexInitialized: function(flexgrid) {
            console.log('flexInitialized');
            this.flex = flexgrid;
            flexgrid.selectionMode = 'CellRange';
            flexgrid.allowSorting = false;
            
            let pkIndex = this.columns.findIndex(el => el.pk === true)
            
            flexgrid.beginningEdit.addHandler((s, e) => {  
                console.log('beginningEdit',e.row,e.col);   
                this.typeSelect.row = e.row
                this.typeSelect.col = e.col
                const identity = this.columns.findIndex(i => i.Identity === true)
                // console.log('identity',identity);
                if (identity != -1 && headName === "Edit table") {
                    // console.log('identityIF',identity);

                }      
                if (e.col === 5 ) {                    
                    this.identityRow = e.row
                    // if (s.cells.getCellData(e.row, 5)) {
                    //     this.$modal.show('open-identity');
                    //     this.seed = this.table.fields[e.row].seed
                    //     this.increment = this.table.fields[e.row].increment
                    // }
                   
                    if (!s.cells.getCellData(e.row, 5)) {
                        // if (s.cells.getCellElement(e.row, 5)) {
                        
                        if (e.data.target.getAttribute('type') == 'checkbox') {
                            this.$modal.show('open-identity');
                        }
                        // }
                        // if (this.table) {
                        //     this.seed = this.table.fields[e.row].seed
                        //     this.increment = this.table.fields[e.row].increment
                        // }
                    }
                    if (!s.cells.getCellElement(e.row, 6).children[0].children[0].checked) {
                        s.cells.getCellElement(e.row, 6).children[0].children[0].click()
                    }
                    if (s.cells.getCellData(e.row, 5)) {
                        if (!(e.data.target.getAttribute('type') == 'checkbox')) {
                            this.$modal.show('open-identity');
                            // console.log('col5')
                            if (this.table) {
                                // console.log('col5_1')
                                this.seed = this.table.fields[e.row].seed
                                this.increment = this.table.fields[e.row].increment
                            }
                        } else if (this.table && e.data.target.getAttribute('type') == 'checkbox') {
                            // console.log('col5-2')
                            // this.$modal.show('open-identity');
                            // this.seed = this.table.fields[e.row].seed
                            // this.increment = this.table.fields[e.row].increment
                        }  
                    } 
                }               
                let item = e.getRow().dataItem;
                if (item.readonly) {
                    e.cancel = false;
                    var dataType = e.panel.columns[e.col].dataType;
                    if (dataType == wijmo.DataType.Boolean) {
                        e.data.target.checked = !e.data.target.checked; // disabling checkbox workaround
                    }
                }
                /*
                if (e.col === 2 ) {
                    console.log('beginningEdit col2');
                    if (!this.columns[e.row].nullable) {
                        s.cells.getCellElement(e.row, 6).children[0].childNodes[0].click()
                    }
                    // console.log('pk',flexgrid.cells.getCellElement(0, 2));
                    // wijmo.addClass(flexgrid.cells.getCellElement(0, 2), "wj-state-disabled")
                    // for (let index = 0; index < this.columns.length; index++) {
                    //     for (let index = 0; index < this.columns.length; index++) {
                    //     // console.log(flexgrid.getCellData(index,5));
                    //         if (!flexgrid.getCellData(index,2)) {
                    //         } 
                    //     }      
                    // }   
                }
                */ 
                if (e.col === 6) {
                    if((this.columns[e.row].pk === true)) {
                        s.cells.getCellElement(e.row, 2).children[0].childNodes[0].click()
                    }
                }
                flexgrid.formatItem.addHandler((s, event) => {
                    // console.log('beginningEdit format');
                    // console.log('format', flexgrid);
                    if (event.col === 3 && event.row === e.row) {
                        // console.log('beginningEdit format if1');
                        if (s.getCellData(e.row,2)) {
                            // console.log('beginningEdit format if1_1', wijmo.addClass(s.cells.getCellElement(e.row, 3)))
                            // console.log('PK3_1');                 
                            wijmo.addClass(s.cells.getCellElement(e.row, 3), "wj-state-disabled")
                        } else {
                            // console.log('beginningEdit format else', wijmo.addClass(s.cells.getCellElement(e.row, 3)))
                            // console.log('PK3_2');      
                            wijmo.removeClass(s.cells.getCellElement(e.row, 3), "wj-state-disabled")
                        }
                    }
                    /*
                    if (event.col === 2 && event.row === e.row) {
                        // console.log('PK2_1');                 
                        if (s.getCellData(e.row,3)) {
                            wijmo.addClass(s.cells.getCellElement(e.row, 2), "wj-state-disabled")
                        } else {
                            // console.log('PK2_2');                 
                        }
                    }
                    */ 
                   if (this.columns.findIndex(i => i.pk === true) !== -1) {
                       if (event.row) {                
                           wijmo.addClass(s.cells.getCellElement(event.row,2), "wj-state-disabled")
                           if(e.row !== 0) {
                               // console.log('beginningEdit format if2_2'); 
                               wijmo.addClass(s.cells.getCellElement(0,2), "wj-state-disabled")
                           }
                       } else {
                           // console.log('beginningEdit format if2_else');
                           wijmo.removeClass(s.cells.getCellElement(this.columns.findIndex(i => i.pk === true),2), "wj-state-disabled")
                       }
                   } else {                      
                   }
                    

                    // if(e.col === 5) {
                    //     // console.log('e.col5');
                    //     if (!e._data.path) {
                    //         return
                    //     }
                    //     if (e._data.path[0].checked) {
                    //         for (let index = 0; index < this.columns.length; index++) {
                    //             if (e.row == index) {
                    //                 wijmo.addClass(s.cells.getCellElement(index, 6), "wj-state-disabled")
                    //             }
                    //             if (!s.getCellData(index,5)) {
                    //                 wijmo.addClass(s.cells.getCellElement(index, 5), "wj-state-disabled")
                    //             } 
                    //         }
                    //     } else {
                    //         for (let index = 0; index < this.columns.length; index++) {
                    //             // if (!s.getCellData(index,5)) {
                    //                 wijmo.removeClass(s.cells.getCellElement(index, 5), "wj-state-disabled")
                    //             // }
                    //             if (e.row == index) {
                    //                 wijmo.removeClass(s.cells.getCellElement(index, 6), "wj-state-disabled")
                    //             } 
                    //         }
                    //     }                       
                    // }
                    // if (event.col === 5) {
                    //     // console.log('event.col5');
                    //     if (identity >= 0) {
                    //         for (let index = 0; index < this.columns.length; index++) {
                    //         // console.log(flexgrid.getCellData(index,5));
                    //             if (!flexgrid.getCellData(index,5)) {
                    //                 wijmo.addClass(flexgrid.cells.getCellElement(index, 5), "wj-state-disabled")
                    //             } 
                    //         }                
                    //     }                                           
                    // }
                    // console.log('beginEdit',s.cells.getCellData(e.row, e.col));
                }) 
                if (e.col == 1) {
                    console.log('e',e);
                }
            });
            
            // this.gridtypemap = new wjcGrid.DataMap(this.typemap3, 'id', 'name');
           
            this.gridtablemap = new wjcGrid.DataMap(this.GetTables(this.db,2), 'tablename', 'tablename'); 
            // this.gridtypemap.getDisplayValues = (dataItem) => {
            //     console.log('dataItem',dataItem);
            //     let validTypes = dataItem;
            //     return validTypes;
            // };
            
            const identity = this.columns.findIndex(i => i.Identity === true)
            const headName = this.$refs.modalHeader.innerText;
           
            setTimeout(() => {
                if (identity != -1 && headName === "Edit table") {
                    for (let index = 0; index < this.columns.length; index++) {
                        if (!flexgrid.getCellData(index,5)) {
                            wijmo.addClass(flexgrid.cells.getCellElement(index, 5), "wj-state-disabled")
                        } 
                    }                           
                } 
                // else if (headName === "Edit table") {
                //     for (let index = 0; index < this.columns.length; index++) {
                //     //     if (!flexgrid.getCellData(index,5)) {
                //             wijmo.addClass(flexgrid.cells.getCellElement(index, 5), "wj-state-disabled")
                //         // } 
                //     }   
                // }
                /*
                this.columns.forEach((el,i) => {
                    if ( i !== pkIndex ) {
                        // console.log('getCellData',
                        //     flexgrid.cells,                       
                        //     flexgrid.cells.getCellElement(i,2)
                        //     );
                        wijmo.addClass(flexgrid.cells.getCellElement(i,2), "wj-state-disabled")
                    }
                })
                */ 
            }, 100);                
            flexgrid.cellEditEnded.addHandler((s, e) => {
                const val = s.cells.getCellData(e.row, e.col)
                console.log('cellEditEnded',val);
                const prop = s.columns.getColumn(e.col)._hdr
                if (e.row > -1 && e.row < this.ancorColumns - 1) {
                    console.log('cellEditEnded IF1');
                    if (prop == 'Name') {
                        this.rename[e.row] = `${this.table.fields[e.row].name} ${val}`
                    } else {
                    
                    }
                }
                if (e.col == 5) {
                    console.log('cellEditEnded IF2');
                    if (s.cells.getCellData(e.row, e.col) == false) {
                        delete this.columns[e.row].increment 
                        delete this.columns[e.row].seed 
                    } 
                    if (s.cells.getCellData(e.row, e.col) == true) {
                        // console.log('this.table',this.table,e.row);
                        if (this.table) {
                            this.seed = this.table.fields[e.row].seed                            
                            this.increment = this.table.fields[e.row].increment
                        }
                    }
                }
                if (e.col == 1) {  
                    console.log('cellEditEnded IF3');
                    console.log('end',e);
                }                
            })
            // flexgrid.hostElement.addEventListener(flexgrid,e => {
            //     console.log("e",e);
            // })
            this.gridtypemap = new wjcGrid.DataMap(this.typemap4, 'id', 'name');
            flexgrid.addEventListener(flexgrid.hostElement, 'click', function(e) {
            var ht = flexgrid.hitTest(e);
            console.log('flexgrid.addEventListener',ht.col);
            if (ht.panel == flexgrid.cells) {
                flexgrid.panel
                // console.log('you clicked cell ',  ht.row);
                if(ht.col == 1) {
                    window.hostname.rowEdit = ht.row
                }
                // console.log('this.typeSelect.row ', window.hostname.rowEdit);
            } 
            }, true)
        },
        startEditing(flex) {
            console.log('startEditing');
            let index = flex.selection.col,
            col = index > -1 ? flex.columns[index] : null;
            // console.log('col.dataType',col);
            if (col && !col.isReadOnly && col.dataType != 3) {
                // console.log('1');
                setTimeout(() => {
                    flex.startEditing(false); // quick mode
                }, 50); // let the grid update first
            }
        },
        GetTblFields(val, selected){
            //console.log('GetTblFields('+val+'). columns count:'+this.columns.length);
            var r = [];
            for (let i = 0; i < this.table.fields.length; i++) {
                const e = this.table.fields[i];
                if(!selected.find(a=>a.name == e.name) || e.name === val)
                    r.push(e);
            }
            return r;
        },
        CreateTable(){  
            this.addColumn =[]
            this.deleteColumn = []
            this.alterColumn = []
            console.log('CreateTable');
            let countRowversion = 0
            this.columns.forEach((item) => {
                if (item.type == 11) {
                    console.log('if 1');
                    countRowversion++
                }
            })
            if (countRowversion>1) {
                console.log('if 2');
                this.ShowAlert('Only one rowversion column is allowed per table');
                return;
            }
            let countIdentity = 0
            this.columns.forEach((item) => {
                if (item.Identity) {
                    console.log('if 3',item.type, (item.type == 'int' || item.type == 'bigint' || item.type == 10 || item.type == 1));
                    countIdentity++
                    if (!(item.type == 'int' || item.type == 'bigint' || item.type == 10 || item.type == 1)) {
                        // console.log('if 3_1');
                        this.ShowAlert('The data type of the "Identity" column does not belong to the "INT" or "BIGINT" types');
                        return;
                    }
                }
            })
            if (countIdentity>1) {
                console.log('if 4');
                this.ShowAlert('Only one identity column is allowed per table');
                return;
            }
            if(!this.CheckNameIsValid(this.name)){
                // console.log('if 5');
                this.ShowAlert('Enter valid table name');
                return;
            }
        //   let r=`ALTER TABLE [${this.table.tablename}] `;
            let r=[];
            let strAlter
            for (let i = 0; i < this.columns.length; i++) {
                const e = this.columns[i];
                // if(e.readonly){
                
                if(!this.CheckNameIsValid(e.name)){
                    // console.log('if 6_1');
                    this.ShowAlert('Enter valid column name');
                    return;
                }
                if(!e.type){
                    // console.log('if 6_2');
                    this.ShowAlert('Enter column type');
                    return;
                }
                if(e.fk && !e.linktable){
                    // console.log('if 6_3');
                    this.ShowAlert('Enter FK table');
                    return;
                }
                let cmd
                // console.log('e.type',e.type);
                if (e.type) {   
                    // let ind = this.typemap4.findIndex( i => i.id == e.type )                 
                    // if (ind != -1) {
                    cmd = '['+e.name+']' + ' ' + e.type +  (e.Identity? ' IDENTITY(' + this.seed + ',' + this.increment + ')' : '') + (e.pk?' PRIMARY KEY':'')+ (e.nullable?' NOT NULL':'') + (e.fk?' , FOREIGN KEY('+'['+e.name+']'+') REFERENCES '+ e.linktable:'');
                    // }
                }
                // }
                if (!this.editmode) {
                    console.log('create',this.editmode);
                    r.push(cmd)
                    console.log('Createtbl Query',r);
                }
            }
            if(this.editmode) {
                console.log('if edit 1');                               
                let oldArr = [];
                for (let i = 0; i < this.table.fields.length; i++) {
                    const e = this.table.fields[i];
                    oldArr.push({type:''+e.type,name:e.name,subtype:e.subtype,nullable: e.nullable==0 ? 1 : 0 ,linktable:e.linktable,pk:e.subtype==1,fk:e.subtype==2, readonly:true,Identity:e.increment ? true : false, precision: e.precision, scale: e.scale});
                }  
                // console.log('oldArr',oldArr);                                
                // console.log('columns',this.columns);                                
                let query = []   
                this.columns.forEach((item,i) => {
                    if(item.index >= 0) {
                        query.push(item.index)      
                    }
                })     
                // console.log('query',query);          
                let numbers = Array.from({length: oldArr.length}, (_, i) => i)

                // console.log('query',query); 
                // console.log('numbers',numbers); 
                let difference = numbers.filter(x => !query.includes(x)).concat(query.filter(x => !numbers.includes(x)));
                // console.log('if 6_4 difference',difference); 
                
                difference.forEach((element,i) => {
                    if (oldArr[element] !== undefined) {
                        this.deleteColumn.push(oldArr[element].name)
                    }
                });                
                if (this.columns.length > oldArr.length) {
                    // console.log('indAdd0',this.columns.length-1);
                    this.createCmd(this.columns.length-1)
                }; 
                if (this.columns.length <= oldArr.length) {
                    let bool = difference.find(el => el == oldArr.length-1)
                    // console.log('bool',bool);
                    if (bool !== undefined) {
                        if ((oldArr.length - difference.length) > 0) {
                            // console.log('indAdd1',oldArr.length - difference.length);
                            this.createCmd(oldArr.length - difference.length)                            
                        } else if((oldArr.length - difference.length) == 0) {
                            // console.log('indAdd2',oldArr.length - difference.length);
                            this.createCmd(1) 
                        } else {
                            // console.log('indAdd3',0);
                            this.createCmd(0)  
                        }
                    } else {
                        // console.log('indAdd4',0);
                        this.createCmd(oldArr.length - difference.length)
                    }
                }                 
                if (query.length > 0) {                    
                    query.forEach((el,i) => {
                        // console.log('query',el);
                        // console.log('this.columns[el]',this.columns.find(it => it.index === el));
                        // console.log('oldArr[el]',oldArr[el]);
                        let newName = this.columns.find(it => it.index === el)
                        if (newName.name != oldArr[el].name) {
                        // if (this.arr[i].name != oldArr[el].name) {
                            this.renameQuery.push(`${oldArr[el].name} ${newName.name}`)
                            // this.renameQuery.push(`${oldArr[el].name} ${this.arr[i].name}`)
                        }
                    })                    
                    let newVal
                    for (let i = 0; i < query.length; i++) {  
                        // console.log('columns',this.columns[i].name);
                        let ind = query[i]                           
                        // console.log('ind query[i]',ind);
                        // if (ind === undefined) {
                        //     ind = i                            
                        //     console.log('ind',ind);
                        // }
                        // console.log('columns',this.columns);
                        // console.log('ind',ind);
                        let newVal = this.columns.find(el => el.index === ind)
                        // console.log('newVal',newVal);
                        // for(let key in this.columns[ind]){
                        for(let key in newVal){
                            // for(let key in this.arr[i]){
                            if (key == 'type') {  
                                // let val = newVal.type.replace(/\s\(+[^(]*/g, '') 
                                let val = newVal.type.replace(/[ \t]/g, '') 
                                // let valOld = this.typePrecision(oldArr[ind]).replace(/\s\(+[^(]*/g, '')
                                // console.log('typePrecisionvalOld', this.typePrecision(oldArr[ind]));
                                let valOld = this.typePrecision(oldArr[ind]).replace(/[ \t]/g, '')
                                console.log('type',val ,valOld);
                                if (val != valOld) {
                                    // console.log('check if');
                                    this.alterColumn[ind] = newVal
                                    break                                    
                                }                             
                            } 
                            // let newVal = this.columns.find(el => el.index === ind)
                            if( key !== 'name' && key != 'type' && newVal[key] !== oldArr[ind][key] && key !== 'index' ){                                                                                                             
                                // console.log('this.columns[ind][key]', newVal[key]);      
                                // console.log('oldArr[ind][key]', oldArr[ind][key]);      
                                // if (key == 'nullable ' && oldArr[ind][key] == 1 && this.columns[i][key] === true) {
                                // console.log('columns', this.columns[ind][key]);      
                                // }
                                this.alterColumn[ind] = newVal
                                break
                            }   
                        }                                      
                    }
                    // console.log('Alter tbl', this.alterColumn)
                    this.alterColumn.forEach((element,i) => { 
                        if (!this.isEmpty(element)) {
                            const e = element;
                            // let cmd = oldArr[i].name + ' ' + (e.type?this.typemap2[e.type]:'') + (e.Identity? ' IDENTITY(' + this.seed + ',' + this.increment + ')' : '') + (e.pk?' PRIMARY KEY':'') + (e.nullable?' NOT NULL':'') +  (e.fk?' FOREIGN KEY('+'['+oldArr[i].name+']'+') REFERENCES '+ e.linktable:'');
                            let cmd = oldArr[i].name + ' ' + e.type + (e.Identity? ' IDENTITY(' + this.seed + ',' + this.increment + ')' : '') + (e.pk?' PRIMARY KEY':'') + (e.nullable?' NOT NULL':'') +  (e.fk?' FOREIGN KEY('+'['+oldArr[i].name+']'+') REFERENCES '+ e.linktable:'');
                            this.alterColumnQuery.push(cmd)
                        }
                    });
                    // this.deleteColumn.forEach(el => deleteCol += ' ' + el)
                }
                
                if (this.addColumn.length >0 || this.alterColumnQuery.length >0 || this.deleteColumn.length >0 || this.renameQuery.length >0) strAlter = 'ALTER TABLE ' + this.table.tablename
                if (this.deleteColumn.length >0) r.push('DROP COLUMN ' + this.deleteColumn.join(', '))
                if (this.addColumn.length >0) r.push('ADD COLUMN ' + this.addColumn.join(', '))
                if (this.alterColumnQuery.length >0) r.push('ALTER COLUMN ' + this.alterColumnQuery.join(', '))
                if (this.renameQuery.length >0) r.push('RENAME ' + this.renameQuery.join(', '))
                // console.log('alterColumnQuery',this.alterColumnQuery);                    
                // console.log('renameQuery',renameQuery); 
                this.addColumn = []
                this.alterColumnQuery = []
                this.deleteColumn = []
                this.renameQuery = []
                this.arr = []
                console.log('query',r);                   
            } 
            if(r.length == 0){
                    console.log('if 7',r);
                    if(this.editmode)
                    // console.log('if 7_1');
                        this.ShowAlert('Enter at least one column');
                    return;
            }
            if(this.editmode){
                console.log('editmode if8',this.editmode);
                // console.log('if 8');
                let query
                this.ExecScript(this.db, strAlter + ' ' + r.join(', ') ,response=>{
                    // console.log('cr tbl',response.data[0].err);            
                    if (response.data[0].err != ""){
                        this.ShowAlert(`Error: ${response.data[0].msg}`);
                        return
                    } else {
                        this.LoadDbFromServer(this.db, (response)=>{
                            // console.log('saved ', response);
                            for (let i = 0; i < response.data.data.length; i++) {
                                const t = response.data.data[i];
                                if(t.tablename == this.name){
                                    this.tab.table = t;
                                    // console.log('setting readonly',t);
                                    for (let j = 0; j < this.columns.length; j++) {
                                        const e = this.columns[j];
                                        e.readonly = true;
                                    }
                                    this.ShowAlert('Saved')
                                    this.ancorColumns = this.columns.length;
                                    break;
                                }
                            }
                            //this.table = response.data.data;
                            let close = document.getElementsByClassName('wj-state-active')[0].children[0]   
                            // console.log('close',close); 
                            close.click()            
                        })
                    }
                },true,this.tab.idconnect,this.state.guid)
            } else {
                // console.log('else 9');
                this.ExecScript(this.db, `CREATE TABLE [${this.name}] (${r.join(',')}) `,response=>{
                    if (!response.data[0].err){
                        this.LoadDbFromServer(this.db, (response)=>{
                            for (let i = 0; i < response.data.data.length; i++) {
                                const t = response.data.data[i];
                                if(t.tablename == this.name){
                                    this.tab.table = t;
                                    for (let j = 0; j < this.columns.length; j++) {
                                        const e = this.columns[j];
                                        e.readonly = true;
                                    }
                                    this.ShowAlert('Saved');
                                    this.ancorColumns = this.columns.length;
                                    break;
                                }
                            }
                        })
                    } else {
                        this.ShowAlert(`Error: ${response.data[0].msg}`);
                    }
                },true,this.tab.idconnect,this.state.guid)
            }
            console.log('cr tab');
        },
        DeleteColumn(col, rowIdx){
            // console.log('delCol', this.table.fields.length);
            // if (rowIdx > -1 && rowIdx <= this.table.fields.length-1) {
            //     console.log('delCol', rowIdx);
            //     this.delColumnQuery += `DROP COLUMN [${col.name}], `
            //     console.log('delCol', this.delColumnQuery);
            // }

            let idx = this.columns.indexOf(col);
            if (idx > -1){
                this.flex.collectionView.removeAt(idx);
            }
        },
        createCmd(ind) {
            // console.log('createCmd',ind,this.columns.length);
            /*
            // for (let i = ind; i < this.arr.length; i++) {
            for (let i = ind; i < this.columns.length; i++) {
                // const e = this.arr[i];
                const e = this.columns[i];
                let ind = this.typemap4.findIndex( i => i.id == e.type )                 
                let cmd
                if (ind != -1) { 
                    cmd = '['+e.name+']' + ' ' + this.typemap4[ind].name +  (e.Identity? ' IDENTITY(' + this.seed + ',' + this.increment + ')' : '') + (e.pk?' PRIMARY KEY':'')+ (e.nullable?' NOT NULL':'') + (e.fk?' FOREIGN KEY('+'['+e.name+']'+') REFERENCES '+ e.linktable:'');
                }
                this.addColumn.push(cmd);
            }
            */
            for (let i = ind; i < this.columns.length; i++) {
                const e = this.columns[i];
                let cmd = '['+e.name+']' + ' ' + e.type +  (e.Identity? ' IDENTITY(' + this.seed + ',' + this.increment + ')' : '') + (e.pk?' PRIMARY KEY':'')+ (e.nullable?' NOT NULL':'') + (e.fk?' FOREIGN KEY('+'['+e.name+']'+') REFERENCES '+ e.linktable:'');
                this.addColumn.push(cmd);
            }
        },
        isEmpty(obj) {
            for (const prop in obj) {
                if (Object.hasOwn(obj, prop)) {
                    return false;
                }
            }
            return true;
        }
    },
}
</script>
<style scoped>
.identity-body {
  width: 30%;
  margin-bottom: 10px;
  height: 30%;
}
.container-ident {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-identity {
  padding-left: 2px;
  cursor: pointer;
  font-size: 8px;
  margin-left: 5px;
  background-color: rgb(247, 247, 247);
  border: 1px solid rgba(0, 0, 0, 0.2);
  width: 16px;
  height: 13px;
}
input {
  /* margin-left: 10px; */
}
.input-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-size: 13px;
}
.modal-title {
    font-size: 13px;
}
.col-name{
    width: 30%;
}
.col-type{
    width: 25%;
}
.col-fk{
    width: 5%;
}
.col-fklink{
    width: 25%;
}
.col-del{
    width: 5%;
}
.modal-body{
    /* height: calc(100% - 83px); */
    overflow-y: auto;
    height: auto;
}
.v-select {
    margin: 0;
}
.table th, .table td {
    border: none;
}
input[type="radio"], input[type="checkbox"] {
    height:16px;
    margin-top: 7px;
}
.wj-flexgrid{
    height: initial;
}
.close {
    cursor: pointer;
    line-height: initial;
    opacity: .5;
    font-weight: 100;
    font-size: 22px;
    margin-top: 2px;
}
.cancel {
    margin-left: 20px;
}
.identity-all {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
.identity-header {
    display: flex;
    justify-content: space-between;
}
.wj-cell .cell-editor {
        position: absolute; 
        left: 0px;
        width: 100%; 
        border-radius: 0px;
        margin: -4px 0 -3px 0;
    }
</style>
